// Util to handle get/set of local storage
// @todo: Test need for fallback to cookies
export default {
  hasStorage: localStorage && typeof localStorage.getItem === "function",

  getLocalStorage: function (key) {
    // Get value from local storage or cookies

    if (!this.hasStorage) {
      return this.getCookie(key);
    }

    var value = localStorage.getItem(key);
    return value;
  },
  setLocalStorage: function (key, value) {
    // Set value in local storage or cookies

    if (!this.hasStorage) {
      this.setCookie(key, value);
    }

    try {
      localStorage.setItem(key, value);
    } catch (e) {
      // Don't store for private browsing
      console.log(
        "Local Storage failed, check if browsing in Safari private window."
      );
    }
  },
  removeLocalStorage: function (key) {
    if (!this.hasStorage) {
      this.removeCookie(key);
    }
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // Don't remove for private browsing
      console.log(
        "Local Storage failed, check if browsing in Safari private window."
      );
    }
  },
  getSessionStorage: function (key) {
    // Get value from Session storage or cookies

    if (!this.hasStorage) {
      return this.getCookie(key);
    }

    var value = sessionStorage.getItem(key);
    return value;
  },
  setSessionStorage: function (key, value) {
    // Set value in Session storage or cookies

    if (!this.hasStorage) {
      this.setCookie(key, value);
    }

    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      // Don't store for private browsing
      console.log(
        "Session Storage failed, check if browsing in Safari private window."
      );
    }
  },
  removeSessionStorage: function (key) {
    if (!this.hasStorage) {
      this.removeCookie(key);
    }
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      // Don't remove for private browsing
      console.log(
        "Session Storage failed, check if browsing in Safari private window."
      );
    }
  },
  getCookie: function (key) {
    // Get value from cookie

    var encodedName = encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&");
    var regex = new RegExp(
      "(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$"
    );

    return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
  },
  setCookie: function (key, value, days, sameSite, domain) {
    let expires = "";
    let domainLevel = ``;
    if (domain) {
      domainLevel = `; domain=${domain}`;
    }
    let sameSiteVal = sameSite ? sameSite.toLowerCase() : false;
    let sameSiteString = `samesite=${
      (sameSiteVal && sameSiteVal == "strict") || sameSiteVal == "lax"
        ? sameSiteVal
        : "none"
    }`;
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    }
    document.cookie =
      key + "=" + value + ";path=/;" + sameSiteString + expires + domainLevel;
  },
  removeCookie: function (key) {
    this.setCookie(key, "", -1);
  },
}
